import Reveal, { Eyebrow } from "@/components/Reveal";

const STATS = [
  {
    value: "+15 años",
    label: "Liderando soluciones de TI en el Occidente mexicano",
  },
  {
    value: "100%",
    label: "Conformidad con regulaciones gubernamentales y CNE",
  },
  {
    value: "<15 min",
    label: "Tiempo promedio de respuesta ante incidentes críticos",
  },
  {
    value: "24/7/365",
    label: "Monitoreo de redes y centro de operaciones de seguridad",
  },
];

const Differentiators = () => (
  <section id="diferenciadores" className="scroll-mt-24 bg-white py-24 sm:py-28" data-testid="differentiators-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mb-16 max-w-3xl">
        <Reveal>
          <Eyebrow dark>03 — Por qué TIO</Eyebrow>
          <h2 className="mt-4 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-[2.9rem] lg:leading-[1.1]">
            Precisión de ingeniería, cercanía de quien está{" "}
            <span className="text-cyan-600">aquí.</span>
          </h2>
          <p className="mt-5 max-w-xl font-body text-[15px] leading-relaxed text-slate-600 sm:text-base">
            No somos un proveedor remoto: estamos en la región, respondemos en minutos y hablamos
            el idioma de la normativa pública venezolana.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.value} delay={i * 0.09}>
            <div
              data-testid={`stat-item-${i}`}
              className="hairline-dark-t pt-6"
            >
              <p className="font-heading text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
                {s.value}
              </p>
              <p className="mt-3 max-w-[220px] font-body text-sm leading-relaxed text-slate-600">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Differentiators;
